// extracted by mini-css-extract-plugin
export default {"modalContent":"AddCustomerModal_modalContent__JMdvt"};